/* eslint-disable*/
/* eslint-disable react/jsx-no-bind */
import { Button } from '@mui/material';
import { useHistory } from 'react-router';
import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
// import moment from 'moment';
import moment from 'moment';
import ComputerTwoToneIcon from '@mui/icons-material/ComputerTwoTone';
import ImagesFinder from '../../Components/ImagesFinder/ImagesFinder';
import { ListTable } from '../../Components/ListTable';
import { LOService, notificationServices } from '../../Services';
import { modalActions } from '../../Actions';
// import { POItemsModal } from '../../Components/Modals/POItemsModal';
import BackdropLoader from '../../Components/Loaders/BackdropLoader';
import LeftOverItemsModal from '../../Components/Modals/LeftOverItemsModal/LeftOverItemsModal';
import { filtersInfoChip, handleResponseStreamDownload } from '@/Helpers';
import machine from '../../Images/scan.jpeg';
import { Filter } from 'lucide-react';
import drawerActions from '@/Actions/drawer.actions';
import { useAuth } from '@/Components/Auth/Login/auth';

const TABLE_COLUMNS = [
	{
		title: 'ID',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Store',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Process',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Inventory At Day End Of',
		config: {
			type: 'DATA',
		},
	},
];
const SPECIAL_COLUMNS = [
	{
		title: 'Captured On',
		config: {
			type: 'DATA',
		},
	},
];

const ACTION_COLUMNS = [
	{
		title: 'View',
		config: {
			type: 'VIEW',
		},
	},
	{
		title: 'Remove',
		config: {
			type: 'CANCEL',
		},
	},
];

// {'productId': item[0], 'variantId': item[1]}

const COL_MAP = {
	ID: 'id',
	Store: 'store',
	Process: 'processName',
	'Inventory At Day End Of': 'dayEndOf',
	'Captured On': 'id',
	Remove: 'id',
};

function ProcessClosingsPage(props) {
	const history = useHistory();
	const { toggleAlert, createPath, toggleLeftOverItemsModal, toggleFiltersDrawer } = props;
	const [loading, setLoading] = useState(false);
	const [leftOverInventoryList, setLeftOverInventoryList] = useState([]);
	const [currentFilterState, setCurrentFilterState] = useState({});
	const [filters, setFilters] = useState({});
	const { userConfig = {} } = useAuth();
	const { level } = userConfig?.userDetails || {};

	const handleFind = async (requestOptions) => {
		setLoading(true);
		setFilters(requestOptions);
		const filters = {
			dateRangeFilter: {
				timeType: requestOptions?.timeType?.value,
				from: moment(requestOptions?.dateRange?.from).format(
					'YYYY-MM-DD'
				),
				to: moment(requestOptions?.dateRange?.to).format('YYYY-MM-DD'),
			},
			processTypeIds: requestOptions?.processTypes?.id,
			storeId: requestOptions?.store?.id,
		};
		try {
			const response = await LOService.listLOInventory({
				data: {
					...filters,
				},
			});
			if (response?.statusCode === 200) {
				const data = response?.data?.map((item) => {
					return {
						...item,
						// dayEndOf: moment(item.day).format('YYYY-MM-DD'),
					};
				});

				setLeftOverInventoryList(data);
			}
		} catch (error) {
			// eslint-disable-next-line no-console
			console.log(error);
		} finally {
			setCurrentFilterState(filters);
			setLoading(false);
		}
	};

	const handleAddClick = () => {
		history.push(createPath);
	};

	const handleViewClick = async (item) => {
		setLoading(true);
		try {
			const response = await LOService.listLOInventoryItems({
				id: item?.id,
			});
			if (response?.statusCode === 200) {
				let itemsData = {};
				const skuType = ['INTERMEDIATE', 'INGREDIENT', 'UNPACKED_PRODUCT'];
				if (Array.isArray(response?.data)) {
					itemsData = response?.data?.reduce((acc, invItem) => {
						if (acc?.[invItem?.skuType]) {
							acc?.[invItem?.skuType]?.push(invItem);
						} else {
							acc[invItem?.skuType] = [invItem];
						}
						return acc;
					}, {});
				} else {
					itemsData = Object?.keys(response?.data)?.reduce((acc, invItem) => {
						const currentTypeItems = response?.data?.[invItem];
						acc[invItem] = currentTypeItems?.map((ele) => {
							return {
								...ele,
								qty: ele?.qty ?? ele?.count,
								productName: ele?.name,
								variantName: ele?.variant,
							};
						});
						return acc;
					}, {});	
				}
				const skuTypeWithData = Object.keys(itemsData).filter((ele) => !skuType?.includes(ele));
				const values = skuTypeWithData.flatMap(key => [...itemsData[key]]);
				if(skuTypeWithData?.length > 0) {
					if(itemsData['INGREDIENT']?.length > 0) {
						itemsData['INGREDIENT'].push(...values);
					}else {
						itemsData['INGREDIENT'] = values;
					}
				}
				itemsData = {
					...(itemsData['INTERMEDIATE'] && { INTERMEDIATE: itemsData['INTERMEDIATE'] }),
					...(itemsData['INGREDIENT'] && { INGREDIENT: itemsData['INGREDIENT'] }),
					...(itemsData['UNPACKED_PRODUCT'] && { UNPACKED_PRODUCT: itemsData['UNPACKED_PRODUCT'] })
				};
				toggleLeftOverItemsModal(true, {
					heading: `Day End Inventory of ${item?.processName} on ${item?.dayEndOf}`,
					items: itemsData,
					date: item?.dayEndOf,
					processName: item?.processName,
					isApprove: false,
					advanceBill: false,
					showTotal: false,
					showPdf: false,
					showPoDetails: false,
					width: '60rem',
					height: '40rem',
					excludedColumns: [
						'Packaged',
						'Dispatched',
						'Received',
						'Returned Quantity',
						'Fulfilled',
						'From Process',
						'PO Id',
						'Returned',
						// 'Category Name',
						'Ordered Quantity',
						'Item Price',
						'Tax Percentage',
						'Tax value',
						'Total Item Amount',
						'Discount %',
						'Used For',
						'Recommended Quantity'
					],
					hideItems: false,
					isAdvanceBill: false,
				});
				// toggleOrderItemsModal(true, {
				// items: data,
				// orderId: item?.id,
				// });
			}
		} catch (error) {
			// eslint-disable-next-line no-console
			console.log(error);
		} finally {
			setLoading(false);
		}
	};

	const handleDelete = async (itemId) => {
		setLoading(true);
		try {
			const response = await LOService.deleteLOInventory({
				id: itemId,
			});
			if (response?.statusCode === 200) {
				setLeftOverInventoryList((prevList) => {
					return prevList.filter((item) => { return item?.id !== itemId; });
				});
			}
		} catch (error) {
			// eslint-disable-next-line no-console
			console.log(error);
		} finally {
			setLoading(false);
		}
	};

	const SPECIAL_ITEMS = {
		'Captured On': (ele, val) => {
			const captured = leftOverInventoryList.find((ele) => ele.id === val)?.machine;
			return captured ? (
				<div className='w-[30px] ml-[2rem]'>
					<img src={machine} alt='machine' />
				</div>
			) : (
				<div className='w-[30px] ml-[2rem]'>
					<ComputerTwoToneIcon />
				</div>
			);
		},
		Remove: (itemId, val) => {
			const itemToRemove = leftOverInventoryList.filter((item) => { return item?.id === val; });
			return (
				<Button
					variant='outlined'
					color='error'
					onClick={() => {
						toggleAlert(true, {
							heading: 'Remove',
							handleConfirm: () => {
								handleDelete(itemId);
								toggleAlert(false);
							},
							colorReverse: false,
							cancelText: 'No',
							confirmText: 'Yes',
							message: `Are you sure you to remove day end inventory of ${itemToRemove[0]?.processName || ' '} on ${
									itemToRemove[0]?.dayEndOf
								}?`,
						});
					}}
				>
					Remove
				</Button>
			);
		},
	};
	async function onExportClick(req) {
		try {
			const response = await LOService.getLeftOverInventoryCsv({
				...currentFilterState,
				dateRangeFilter: {
					timeType: req?.timeType?.value,
					from: moment(req?.dateRange?.from).format(
						'YYYY-MM-DD'
					),
					to: moment(req?.dateRange?.to).format('YYYY-MM-DD'),
				},
				processTypeIds: req?.processTypes?.id,
				storeId: req?.store?.id,
			});
			if (response.status === 200) {
				handleResponseStreamDownload(response, `leftover_${currentFilterState?.dateRangeFilter?.from}_${currentFilterState?.dateRangeFilter?.to}.csv`);
			} else {
				notificationServices.generateNotification({
					type: 'error',
					message: 'Some error occurred',
				});
			}
		} catch (error) {
			notificationServices.generateNotification({
				type: 'error',
				message: error,
			});
		}
	}
	const filtersInfo = {
		header: {
			store: false,
			date: false,
			process: false,
		},
		filteredStore: {
			text: 'Store',
			show: true,
		},
		dateRangeOnly: {
			show: true,
			text: 'Monitoring Date range',
		},
		processType: {
			text: 'Process',
			show: true,
		}	
	};
	const exportInfo = {
		showExportBtn : true,
	};

	return (
		<div>
			{/* <OrderItemsModal /> */}
			{/* <POItemsModal /> */}
			<LeftOverItemsModal />
			<BackdropLoader isLoading={loading} showProgress />
			<div
				style={{
					padding: '10px',
				}}
			>
				<ImagesFinder
					onSubmit={handleFind}
					FILTERS={['filteredStore', 'dateRangeOnly', 'processTypes']}
					filterLabels={{
						store: 'Store',
						processTypes: 'Process',
						dateRangeOnly: 'Left Over Inventory Date Range',
					}}
					filtersInfo={filtersInfo}
					exportInfo={exportInfo}
				/>
				<div className='flex justify-between m-4 p-2 items-center'>
					<span className='font-bold text-[16px]'>Left Over Inventory</span>
					<div className='flex gap-2'>
						<Button
							onClick={() => {
								toggleFiltersDrawer(true, {
									handleDataExport : (req) => onExportClick(req),
								});
							}}
							className='flex justify-center gap-2 px-4 py-2 text-white bg-teal-600 border border-gray-300 rounded-md hover:bg-teal-700'
						>
							<span className='text-nowrap capitalize'>Filter & Export</span>
							<Filter className='size-4' />
						</Button>
						{level !== 1 && (
							<Button
								className='bg-yellow-400 hover:bg-yellow-500 rounded-md flex items-center justify-center gap-2 text-black'
								onClick={handleAddClick}
						>
								+ Add Left Over Inventory
							</Button>
						)}
					</div>
				</div>
			</div>
			{filtersInfoChip(filtersInfo, filters)}
			<ListTable
				data={leftOverInventoryList}
				columns={TABLE_COLUMNS}
				colMap={COL_MAP}
				actions={[...SPECIAL_COLUMNS, ...ACTION_COLUMNS]}
				handleViewClick={handleViewClick}
				allowExport={false}
				special={SPECIAL_ITEMS}
				showBtnContainer={false}
			/>
		</div>
	);
}

const mapStateToProps = (state) => {
	const { LIST: productsList } = state.form.ALL_PRODUCTS.data;
	return {
		productsList,
	};
};
const mapDispatchToProps = {
	toggleAlert: modalActions.toggleAlert,
	toggleOrderItemsModal: modalActions.toggleOrderItemsModal,
	toggleLeftOverItemsModal: modalActions.toggleLeftOverItemsModal,
	toggleFiltersDrawer: drawerActions.toggleFiltersDrawer,
};

export default connect(mapStateToProps, mapDispatchToProps)(ProcessClosingsPage);
